import {useTranslation} from "next-i18next";
import CustomListbox, {Item} from "./CustomListbox";

interface SidebarDropdownSelectPropsInterface {
	dropDowns: {
		title: string;
		items: string[] | undefined;
		singleChoice?: boolean;
		defaultChecked?: string[] | undefined;
	}[];
	onSelectItems: (key: string, items: Item[]) => void;
}

export default function SidebarDropdownSelect(
	props: SidebarDropdownSelectPropsInterface
) {
	const {t} = useTranslation();
	return (
		<div className="flex gap-7">
			{props.dropDowns.map((dropDown) => {
				return (
					<div
						className={`grow ${props.dropDowns.length > 1 ? "w-2/4" : ""}`}
						key={dropDown.title}
					>
						<span className="input-caption">{t(dropDown.title)}</span>
						<CustomListbox
							singleChoice={dropDown.singleChoice}
							items={(dropDown.items ?? []).map((item) => {
								return {name: item};
							})}
							defaultChecked={
								dropDown.defaultChecked?.map((checked) => {
									return {name: checked};
								}) as Item[]
							}
							onSelectItems={(items) => {
								if (
									items !==
									(props.dropDowns.map((dropdown) => {
										return dropdown.defaultChecked;
									}) as unknown as Item[])
								)
									props.onSelectItems(
										dropDown.title,
										items.filter((item) => item.name != undefined)
									);
							}}
						/>
					</div>
				);
			})}
		</div>
	);
}
